import { render, staticRenderFns } from "./DialogCreateSlope.vue?vue&type=template&id=72ccd1c3"
import script from "./DialogCreateSlope.vue?vue&type=script&lang=js"
export * from "./DialogCreateSlope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports